import React, {useCallback, useState, useEffect} from 'react';
import {isMobile} from 'react-device-detect';
import {useFilterWorks} from './useFilterWorks.js';
import {useScroll} from './useScroll.js';
import {useMonths} from './useMonths.js';
import Months from './Months.js';
import {getBlockMonths} from 'utils/getBlockMonths.js';
import PulseLoader from 'react-spinners/PulseLoader'
import Work from './Work.js';
import { connect } from "react-redux";
import {
    NUM_TRACKS,
    ADD_TRACKS,
    LOAD_TIME
} from './constants.js';

const Works = ({
    allSequences,
    onClickWork,
    onClickMix,
    onClickList,
    loadSample,
    searchTerm,
    searchOptions,
    personSelected,
    setSearchTag,
    worksLoaded}) => {
        let [state, setState] = useState({numTracks: Math.floor(NUM_TRACKS * window.innerWidth / 1000), scrollTop: 0});
        let {scrollTop, numTracks} = state;

        let {
            userWorks,
            works,
            setIsLoading,
            isLoading} = useFilterWorks({
                allSequences,
                searchTerm,
                searchOptions,
                setState
            });

        let {
            months,
            onClickMonth,
            setCurrentMonth,
            currentMonth} = useMonths({
                setIsLoading,
                setState,
                userWorks
            });

        let {
            onScroll,
            scrollWorks,
            toSkip} = useScroll({
                works,
                setIsLoading,
                isLoading,
                state,
                setState,
                userWorks,
                setCurrentMonth,
                months,
                personSelected});
        
        //{!isMobile ? <div style={{height: Math.max(0, scrollTop - 1000)}} className="scroll-empty"/> : ''}
        return (
            <div className="works-and-months">
              <div id="works">
                <div className="works-grid">
                  {scrollWorks.map(
                      (work, i) =>
                          <Work
                            setSearchTag={setSearchTag}
                            loadSample={loadSample}
                            onClick={onClickWork}
                            onClickMix={onClickMix}
                            onClickList={onClickList}
                            key={(i + Math.floor(toSkip)) + '-' + work.newSequence + '-' + work.blockNumber}
                            work={work}
                          />)}
                </div>
                <div className="loader-container">
                  <PulseLoader
                    sizeUnit={"px"}
                    size={20}
                    color={'#42f4f1'}
                    loading={isLoading}
                  />
                </div>
              </div>
              <Months months={months} onClickMonth={onClickMonth} currentMonth={currentMonth}/>
            </div>
        );
    };

const mapStateToProps = (state, props) => {
    return {
        personSelected: state.explore.personSelected,
        allSequences: state.explore.allSequences,
        worksLoaded: state.explore.worksLoaded
    };
};

export default connect(mapStateToProps, null)(Works);


